import styled from 'styled-components'
import { ButtonStyleType } from 'src/types/type'

const JoinSubmitWrap = styled.div`
  max-width: 492px;
  width: 100%;
  margin: 28px auto 15px auto;
  display: block;
`
const CustomBtn = styled.button<ButtonStyleType>`
  cursor: pointer;
  display: block;
  border: none;
  max-width: 456px;
  width: ${(props) => props.width? props.width : '100%' };
  margin: 0 auto 10px auto;
  background-color: ${props => props.disabled? '#eee':props.backgroundColor};
  //background-color: ${(props) => props.backgroundColor};
  font-size: ${props => props.fontSize};
  fontFamily: ${(props) => props.fontFamily};
  color: ${props => props.fontColor ?? '#fff'};
  font-weight: ${props => props.fontWeight ?? 0};
  border-radius: ${props => props.borderRadius};
  letter-spacing: ${props => props.letterSpacing};
  height: ${(props) => props.height? props.height : '54px'};
  line-height: 54px;
  line-height: ${(props)=>props.lineHeight ? props.lineHeight : '54px'};
  @media all and (max-width: 492px) {
    width: 93%;
  }
  > span, > a {
    text-align: center;
    color: ${(props) => props.color};
    line-height: ${(props) => props.height};
    font-family: ${(props) => props.fontFamily};
    font-size: ${(props) => props.fontSize};
  }
`

const NoticeFeeText = styled.p<{fontColor: string, fontSize: string, cashSpace: string}>`
  margin: 5px auto 0 auto;
  width: 93%;
  word-break: keep-all;
  text-align: center;
  font-weight: 700;
  font-size: ${props => props.fontSize};
  letter-spacing: ${props => props.cashSpace};
  color: ${(props) => props.fontColor};
`

export { JoinSubmitWrap, CustomBtn, NoticeFeeText }
